import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import { useLazyQuery } from '@/hooks/use-lazy-query';
import { useWrappedQuery } from '@/hooks/use-wrapped-query';
const defaultOptions = {} as const;

export const SalesPortalAccountListDataPaginatedDocument = gql`
  query SalesPortalAccountListDataPaginated(
    $businessOrganizationUUID: uuid!
    $cursor: uuid
    $filters: SalesPortalAccountListFilters
    $pageSize: Int
    $userTimezone: String
  ) {
    getSalesPortalAccountListInfoPaginated(
      business_organization_id: $businessOrganizationUUID
      cursor: $cursor
      filters: $filters
      page_size: $pageSize
      user_timezone: $userTimezone
    ) {
      accounts {
        last_fulfilled_date_display
        restaurant_account_id
        restaurant_address
        restaurant_id
        restaurant_name
        supplier_id
      }
      cursor
    }
  }
`;
export function useSalesPortalAccountListDataPaginatedQuery(
  baseOptions: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >(SalesPortalAccountListDataPaginatedDocument, options);
}
export function useSalesPortalAccountListDataPaginatedLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >(SalesPortalAccountListDataPaginatedDocument, options);
}
export type SalesPortalAccountListDataPaginatedQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListDataPaginatedQuery
>;
export type SalesPortalAccountListDataPaginatedLazyQueryHookResult = ReturnType<
  typeof useSalesPortalAccountListDataPaginatedLazyQuery
>;
export type SalesPortalAccountListDataPaginatedQueryResult = Apollo.QueryResult<
  Types.SalesPortalAccountListDataPaginatedQuery,
  Types.SalesPortalAccountListDataPaginatedQueryVariables
>;

/**
 * Wrapped version of useGeneratedSalesPortalAccountListDataPaginatedQuery using Pepper's useWrappedQuery
 */
export function useGeneratedSalesPortalAccountListDataPaginatedQuery(
  options?: Apollo.QueryHookOptions<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >,
) {
  return useWrappedQuery<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >(SalesPortalAccountListDataPaginatedDocument, options);
}

/**
 * Wrapped version of useGeneratedSalesPortalAccountListDataPaginatedLazyQuery using Pepper's useLazyQuery
 */
export function useGeneratedSalesPortalAccountListDataPaginatedLazyQuery(
  lazyOptions?: Omit<
    Apollo.QueryOptions<Types.SalesPortalAccountListDataPaginatedQueryVariables>,
    'query'
  >,
) {
  return useLazyQuery<
    Types.SalesPortalAccountListDataPaginatedQuery,
    Types.SalesPortalAccountListDataPaginatedQueryVariables
  >(SalesPortalAccountListDataPaginatedDocument, lazyOptions);
}
